import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLayout.vue?vue&type=style&index=0&id=3e59916a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e59916a"]])

export default __exports__